import { render, staticRenderFns } from "./PageFormatHandler.vue?vue&type=template&id=256118e8&"
import script from "./PageFormatHandler.vue?vue&type=script&lang=js&"
export * from "./PageFormatHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports